import { useEffect, useState } from "react";

const GlucoSearchBox = ({onAddGluco, onDelGluco, onExcelDownload , setYear, setMonth, setGlucoState}) => {
    const addGluco = () => {
        onAddGluco();
    }
    const delGluco = () => {
        onDelGluco();
    }
    const excelDownload = () => {
        onExcelDownload();
    }

    const [years, setYears] = useState([]);
    const seYearSelect = () => {
        let date = new Date();
        let year = date.getFullYear();
        let years = []
        for(let i = 2024; i <= year; i++){
            years.push(i);
        }
        setYears(years);
    }
    useEffect(() => {
        seYearSelect();
    }, []);
    return (
        <div className="search_area" style={{alignItems: "flex-start"}}>
            <div></div>
            <div className="left">
                <div className="select_box insert-wrap">
                    <select id="year" defaultValue="0" onChange={(e) => setYear(e.target.value)}>
                        <option value="0">년도</option>
                        {years.map((year) => (
                            <option key={year} value={year}>{year}</option>
                        ))}
                    </select>
                </div>
                <div className="select_box insert-wrap">
                    <select id="month" defaultValue="0" onChange={(e) => setMonth(e.target.value)}>
                        <option value="0">월</option>
                        <option value="01">1월</option>
                        <option value="02">2월</option>
                        <option value="03">3월</option>
                        <option value="04">4월</option>
                        <option value="05">5월</option>
                        <option value="06">6월</option>
                        <option value="07">7월</option>
                        <option value="08">8월</option>
                        <option value="09">9월</option>
                        <option value="10">10월</option>
                        <option value="11">11월</option>
                        <option value="12">12월</option>
                    </select>
                </div>
                <div className="select_box insert-wrap">
                    <select id="glucoState" defaultValue="0" onChange={(e) => setGlucoState(e.target.value)}>
                        <option value="0">전체</option>
                        <option value="1">정상</option>                                    
                        <option value="2">낮음</option>                                    
                        <option value="3">높음</option>
                        <option value="4">매우낮음</option>                                    
                        <option value="5">매우높음</option>                                    
                    </select>
                </div>
                <div className="xlsx-wrap insert-wrap">
                    <div className="insert insert-input-btn">
                        <input className="btn-xlsx" type="button" value="엑셀다운로드" id="excelDownloadButton" onClick={excelDownload} />
                    </div>
                </div> 
                <div className="xlsx-wrap insert-wrap">
                    <input type="button" className="btn btn-md primary mr-1" value="혈당값 추가" onClick={addGluco} id="addButton" />   
                </div> 
                <div className="xlsx-wrap insert-wrap">
                    <input type="button" className="btn btn-md primary mr-1" style={{backgroundColor: "#ff2b2b"}} value="혈당값 삭제" onClick={delGluco} id="delButton" />   
                </div> 
            </div> 
        </div>
    )
}

export default GlucoSearchBox;